import { connection_platform } from "../services/api";

const storageFilters = !connection_platform.changeRowQueueDashboard ?
[
  {
    title: "Grupo",
    exhib: true,
  },
  {
    title: "Fila",
    exhib: true,
  },
  {
    title: "Tempo de fila",
    exhib: true,
  },
  {
    title: "Maior T. de fila",
    exhib: true,
  },
  {
    title: "Logados",
    exhib: true,
  },
  {
    title: "Recebidas",
    exhib: true,
  },
  {
    title: "Abandonadas",
    exhib: true,
  },
  {
    title: "Total Disponível",
    exhib: true,
  },
  {
    title: "Maior tempo Disponível",
    exhib: true,
  },
  {
    title: "Total Ativos",
    exhib: true,
  },
  {
    title: "Maior tempo Ativos",
    exhib: true,
  },
  {
    title: "Total Pausados",
    exhib: true,
  },
  {
    title: "Maior tempo Pausas",
    exhib: true,
  },
  {
    title: "CSAT",
    exhib: true,
  },
] : [
  {
    title: "Grupo",
    exhib: true,
  },
  {
    title: "Fila",
    exhib: true,
  },
  {
    title: "Maior T. de fila",
    exhib: true,
  },
  {
    title: "Recebidas",
    exhib: true,
  },
  {
    title: "Abandonadas",
    exhib: true,
  },
  {
    title: "CSAT",
    exhib: true,
  },
];

const initialState = localStorage.getItem("filters_manager_columns_groupRow");
let initialJson = storageFilters;

if (initialState) {
  let newColumns = storageFilters;
  let initialJson = JSON.parse(
    localStorage.getItem("filters_manager_columns_groupRow")
  );
  for (const column of initialJson) {
    if (column && Object.keys(column).length > 0) {
      const findColumn = newColumns.find(
        (columnEx) => columnEx.title === column.title
      );
      if (findColumn) {
        findColumn.exhib = column.exhib;
      }
    }
  }
}

const columnsgrouprow = (state = initialJson, action) => {
  switch (action.type) {
    case "CHANGE_COLUMNS_ALL_GROUPROW":
      return action.columns;

    default:
      return state;
  }
};

export default columnsgrouprow;
